import { CommonModule } from '@angular/common';
import { CommonUiModule } from '../common/common-ui.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HardwareDashboardRoutingModule } from './hardware-dashboard-routing.module';
import { TranslationModule } from '../translation.module';
import { MockService } from 'src/app/services/mock/mock.service';
import { PageDashboardComponent } from 'src/app/components/pages/page-dashboard/page-dashboard.component';
import { ContainerCardModule } from 'src/app/components/container-card/container-card.module';
import { UiButtonModule } from 'src/app/components/ui/ui-button/ui-button.module';
import { WidgetQuicksettingsComponent } from 'src/app/components/widgets/widget-quicksettings/widget-quicksettings.component';
import { WidgetQuicksettingsNoteComponent } from 'src/app/components/widgets/widget-quicksettings/widget-quicksettings-note/widget-quicksettings-note.component';
import { WidgetSwitchIconComponent } from 'src/app/components/widgets/widget-switch-icon/widget-switch-icon.component';
import { WidgetSecurityStatusModule } from 'src/app/components/widgets/widget-security-status/widget-security-status.module';
import { NgbCarouselModule, NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PageLayoutModule } from 'src/app/components/page-layout/page-layout.module';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { CommonPipeModule } from '../common/common-pipe.module';
import { WidgetDashboardWarrantyComponent } from 'src/app/components/widgets/widget-dashboard-warranty/widget-dashboard-warranty.component';
import { WidgetSystemUpdateComponent } from 'src/app/components/widgets/widget-system-update/widget-system-update.component';
import { WidgetSupportModule } from 'src/app/components/widgets/widget-support/widget-support.module';
import { WidgetEnergyStarComponent } from 'src/app/components/widgets/widget-energy-star/widget-energy-star.component';
import { WidgetStorageStatusComponent } from 'src/app/components/widgets/widget-storage-status/widget-storage-status.component';
import { WidgetAboutMyDeviceComponent } from 'src/app/components/widgets/widget-about-my-device/widget-about-my-device.component';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { CommonWidgetModule } from '../common/common-widget.module';
import { MatTooltipModule } from '@lenovo/material/tooltip';
import { WidgetFeedbackComponent } from 'src/app/components/widgets/widget-feedback/widget-feedback.component';

@NgModule({
	declarations: [
		PageDashboardComponent,
		WidgetSwitchIconComponent,
		WidgetQuicksettingsComponent,
		WidgetQuicksettingsNoteComponent,
		WidgetSystemUpdateComponent,
		WidgetEnergyStarComponent,
		WidgetDashboardWarrantyComponent,
		WidgetStorageStatusComponent,
		WidgetAboutMyDeviceComponent,
		WidgetFeedbackComponent,
	],
	imports: [
		CommonModule,
		CommonUiModule,
		HardwareDashboardRoutingModule,
		TranslationModule.forChild(),
		ContainerCardModule,
		UiButtonModule,
		WidgetSecurityStatusModule,
		WidgetSupportModule,
		NgbCarouselModule,
		NgbDropdownModule,
		FontAwesomeModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModalModule,
		CommonPipeModule,
		PageLayoutModule,
		MatTooltipModule,
		CommonWidgetModule,
	],
	exports: [
		CommonUiModule,
		ContainerCardModule,
		NgbCarouselModule,
		NgbDropdownModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		PageLayoutModule,
		WidgetDashboardWarrantyComponent,
	],
	providers: [MockService],
	entryComponents: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HardwareDashboardModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faTimes);
		library.addIcons(faExclamationCircle);
		library.addIcons(faCheckCircle);
		library.addIcons(faCopy);
	}
}
